import script from "./serviceDeliver.vue?vue&type=script&setup=true&lang=js"
export * from "./serviceDeliver.vue?vue&type=script&setup=true&lang=js"

import "./serviceDeliver.vue?vue&type=style&index=0&id=07041326&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07041326"]])

export default __exports__